
import axios from "@/services/axios";
import { defineComponent, onMounted, computed } from "vue";
export default defineComponent({
  props: {
    label: {
      type: String,
      default: "Lorem, ipsum dolor.",
    },
    icon: {
      type: String,
      default: "icon-file-1",
    },
    href: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const getFileName = computed(() => {
      return props.label.split("/").pop();
    });

    const onDownloadClick = (event: Event) => {
      axios
        .get(props.href, {
          responseType: "blob",
        })
        .then((response: any) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", props.label);
          document.body.appendChild(link);
          link.click();
        });
      event.preventDefault();
    };

    return {
      onDownloadClick,
      getFileName,
    };
  },
});
